import React, {useState} from 'react';
import Translate from "./Translate";
import {formatSecondsToHHMMSS, tabButtonStyles} from "../utils/General";
import BlockUsers from "../assets/images/block-user.png";
import PlatformIcon from "../components-new/PlatformIcon";

const style = {
    container: {
        backgroundColor: '#ffffff',
        padding: '30px',
        borderRadius: '16px',
        boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
        fontFamily: 'Arial, sans-serif',
        fontSize: '14px',
        color: '#2c3e50',
        margin: '0 auto',
        maxWidth: '600px',
        width: '400px',
        height: '600px',
        overflowY: 'auto'
    },
    section: {
        marginBottom: '25px',
    },
    sectionTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#1a3d5d',
        marginBottom: '10px',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: '5px',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '10px',
        alignItems: 'center',
        fontSize: '12px',
    },
    label: {
        fontWeight: '600',
        color: '#1a3d5d',
    },
    value: {
        textAlign: 'right',
        color: '#4a4a4a',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        flex: 1,
        marginLeft: '15px',
        maxWidth: '50%'
    },
    highlightGreen: {
        color: '#27ae60',
        fontWeight: '600',
    },
    highlightBlue: {
        color: '#2980b9',
        fontWeight: '600',
    },
    blockActionWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        marginTop: '30px',
        fontSize: '12px'
    },
    blockBackground: {
        borderRadius: '50%',
        backgroundColor: '#e74c3c',
        width: '36px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    }
};

const InfoRow = ({label, value, highlight}) => (
    <div style={style.row}>
        <span style={style.label}><Translate text={label}/>:</span>
        <span style={{...style.value, ...(highlight && style[highlight])}}>{value}</span>
    </div>
);

const ConversationDetails = ({conversationDetails, withBlockAction, cancelAction, blockUserClick, fromStatistics}) => {

    const [activeTab, setActiveTab] = useState('chat');

    const {
        conversationId,
        platform,
        status,
        operatorFullName,
        chatWithOperatorRequestCount,
        customerName,
        visitorPlatformId,
        visitorEmail,
        visitorPhoneNumber,
        visitorDevice,
        visitorBrowser,
        visitorIp,
        firstResponseTime,
        conversationTime,
        avrgResponseTime,
        date,
        lastModifiedAt,
        rating,
        categoryName,
        subject,
        description,
        parentSiteUrl,
        botName,
        lastChoseSkillName,
        messagesCount,
    } = conversationDetails;

    return (
        <div style={style.container}>

            <div style={tabButtonStyles.tabButtons}>
                <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'chat')}
                        onClick={() => setActiveTab('chat')}>
                    <Translate text="chat"/>
                </button>

                <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'user')}
                        onClick={() => setActiveTab('user')}>
                    <Translate text="user"/>
                </button>

                <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'time')}
                        onClick={() => setActiveTab('time')}>
                    <Translate text="time"/>
                </button>

                <button style={tabButtonStyles.tabButtonBackgroundSilver(activeTab === 'other')}
                        onClick={() => setActiveTab('other')}>
                    <Translate text="other"/>
                </button>
            </div>

            <React.Fragment>
                {activeTab === 'chat' && (
                    <div style={style.section}>
                        <div style={style.sectionTitle}></div>
                        <InfoRow label="id" value={conversationId}/>
                        <InfoRow label="bot" value={botName}/>
                        <InfoRow label="platform"
                                 value={<PlatformIcon conversation={conversationDetails} size={30}/>}/>
                        <InfoRow label="Status" value={<Translate text={status}/>}/>
                        <InfoRow label="operator"
                                 value={operatorFullName !== 'null null' ? operatorFullName : '-'}/>
                        <InfoRow label="lastChoseSkill" value={lastChoseSkillName || 'N/A'}/>
                        <InfoRow label="messageCount" value={messagesCount}/>
                        <InfoRow label="parentSiteUrl" value={parentSiteUrl}/>
                    </div>
                )}

                {activeTab === 'user' && (
                    <div style={style.section}>
                        <div style={style.sectionTitle}></div>
                        <InfoRow label="user" value={customerName} highlight="highlightBlue"/>
                        <InfoRow label="id" value={visitorPlatformId} highlight="highlightBlue"/>
                        <InfoRow label="email" value={visitorEmail || 'N/A'} highlight="highlightBlue"/>
                        <InfoRow label="phoneNumber" value={visitorPhoneNumber || 'N/A'} highlight="highlightBlue"/>
                        <InfoRow label="ip" value={visitorIp || 'N/A'} highlight="highlightBlue"/>
                        <InfoRow label="device" value={visitorDevice || 'N/A'} highlight="highlightBlue"/>
                        <InfoRow label="browser" value={visitorBrowser || 'N/A'} highlight="highlightBlue"/>
                        <InfoRow label="operatorRequestCount" value={chatWithOperatorRequestCount || 'N/A'}
                                 highlight="highlightBlue"/>
                    </div>
                )}

                {activeTab === 'time' && (
                    <div style={style.section}>
                        <div style={style.sectionTitle}></div>
                        <InfoRow label="firstResponseTime" value={formatSecondsToHHMMSS(firstResponseTime)}
                                 highlight="highlightGreen"/>
                        <InfoRow label="conversationTime" value={formatSecondsToHHMMSS(conversationTime)}
                                 highlight="highlightGreen"/>
                        <InfoRow label="avrgResponseTime" value={formatSecondsToHHMMSS(avrgResponseTime)}
                                 highlight="highlightGreen"/>
                        <InfoRow label="createdAt" value={new Date(date).toLocaleString('en-GB')}/>
                        <InfoRow label="lastModifiedAt" value={new Date(lastModifiedAt).toLocaleString('en-GB')}/>
                    </div>
                )}

                {activeTab === 'other' && (
                    <div>
                        <div style={style.section}>
                            <div style={style.sectionTitle}></div>
                            <InfoRow
                                label="Rating"
                                value={
                                    rating === 'NONE' ? (
                                        'N/A'
                                    ) : (
                                        <span style={{color: rating === 'GOOD' ? 'green' : 'red'}}>
                                               <Translate text={rating + "_text"}/>
                                            </span>
                                    )
                                }
                            />

                            <InfoRow label="category" value={categoryName || 'N/A'}/>
                            <InfoRow label="subject" value={subject || 'N/A'}/>
                            <div style={{...style.row, alignItems: 'flex-start'}}>
                                <span style={style.label}><Translate text="description"/>:</span>
                                <span style={{...style.value, maxWidth: '60%'}}>{description || 'N/A'}</span>
                            </div>
                        </div>

                        {withBlockAction && (
                            <div style={style.blockActionWrapper}>
                                <span style={style.label}><Translate text="blockUserAction"/>:</span>
                                <div onClick={() => {
                                    cancelAction();
                                    blockUserClick();
                                }} style={style.blockBackground}>
                                    <img width={20} height={20} src={BlockUsers} alt="Block User"/>
                                </div>
                            </div>
                        )}

                    </div>
                )}
            </React.Fragment>

        </div>
    );
};

export default ConversationDetails;



// WEBPACK FOOTER //
// ./src/components/ConversationDetails.jsx